/**
 * 订单进度
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/10/15      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from "react";
import { Popover, Timeline } from "antd";
import "./index.less";
class OrderProgress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            code: props.code,
            // 中转站名称
            transitCityName: props.transitCityName,
            // 服务国家名称
            transitCountryName: props.transitCountryName,
            list:[
                // 待确认订金
                {code:10,content:__getServerLanguage('NinZaiZhiFuDingJinHouEssaWeiNinTouChan')},
                // 已支付定金，订单生产中;
                //定金支付成功，您的订单已在安排生产，请留意异常通知;
                {code:40,content:((props.model.joinGroupIng === 1)?__getServerLanguage('YiZhiFuDingJinDaiChengTuan') : __getServerLanguage('DDPStatus40'))},
                // 生产已完成
                // 订单已完成生产，等待质检
                {code:41,content:__getServerLanguage('DDPStatus41')},
                // 质检中
                {code:45,content:__getServerLanguage('ShengChanYiWanBiZhengZaiJinXinZhiJian')},
                // 收货中
                {code:50,content:__getServerLanguage('ShangPinYiZhiJianWanChengZhengZaiShouRuEssaCangKu')},
                // 装柜中
                {code:60,content:__getServerLanguage('DingDanYiJingZhuangGuiWanCheng')},
                // 装柜完成
                {code:70,content:__getServerLanguage('HuoWuYiJingZhuangGuiWanCheng')},
                // 运输中;
                // 您的订单已发出，正发往莫斯科(地点为动态)
                {code:90,content:__getServerLanguage('DDPStatus90'), split: true,},
                // 待支付尾款
                // 你的订单已进入俄罗斯境内，提货前请支付尾款
                {code:100,content:__getServerLanguage('DDPStatus100'), split: true,},
                // 已入库，待提货
                //  增加 101 / 102 根据当前状态显示 对应 其中两行数据 根据flag筛选
                {code:101,content:__getServerLanguage('DDPStatus101'),process:1 },
                {code:106,content:__getServerLanguage('DDPStatus106'),process:1, split: true,},
                // 流程2
                {code:102,content:__getServerLanguage('DDPStatus102'),process:2 },
                {code:105,content:__getServerLanguage('DDPStatus105'),process:2, split: true,},  // 您的订单已达到莫斯科仓库中心，等待提货
                // 已支付尾款
                // 尾款支付成功，订单已完成
                {code:110,content:__getServerLanguage('DDPStatus110')},
            ],
            flagList:[
                {code:10,content:__getServerLanguage('ZhuangTaiShuoMin1')},
                {code:105,content:__getServerLanguage('ZhuangTaiShuoMin2')},
                {code:110,content:__getServerLanguage('ZhuangTaiShuoMin3')},
            ]
        };
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    handleVisibleChange = (visible) => {
        this.setState({ visible });
    };
    getRenderList(stepType=1,list=[]){
        let newList = []
        if(stepType==2){ // 增加 101 / 102 根据当前状态显示 其中2行，即 102状态排除101行，其他排除102
            newList = list.filter(item=>item.process!=1||!item.process);
        }else newList = list.filter(item=>item.process!=2||!item.process);
        return newList
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            code: nextProps.code,
            transitCityName: nextProps.transitCityName,
            transitCountryName: nextProps.transitCountryName,
        });
    }

    render() {
        let { list, code } = this.state;
        const {model,placement,trigger} = this.props;
        if(this.props.model.orderType){
            list = this.state.flagList;
        }
        function strContent(item={}) {
            // console.log('item.content', item.content);
            if (item.split) {
                let name = ''
                if (item.code == 90 || item.code == 105) {
                    name = this.state.transitCityName
                } else if (item.code == 100) {
                    name = this.state.transitCountryName
                }
                let arr = item.content.split('<D/>')
                let str = arr[0] + name + (arr[1]?arr[1]:'')
                return (
                    <p className="tip">{str}</p>
                )
            } else {
                return (
                    <p className="tip">{item.content}</p>
                )
            }
        }
        return (
            <Popover
                autoAdjustOverflow={false}
                content={
                    <div className="order-progress-wrap">
                        <Timeline>
                            {this.getRenderList(model.stepType,list).map((item,index) => {
                                return <Timeline.Item dot={<i className={code==item.code?'active':''}></i>} key={index}>
                                    <p className="name">{this.props.model.orderType?__getServerDictItem('sale_po_ddp_status_buyer_activity.'+item.code):__getServerDictItem('sale_po_ddp_status_buyer.'+item.code)}</p>
                                    {/*<p className="tip">{item.content}</p>*/}
                                    {strContent.call(this,item)}
                                </Timeline.Item>
                            })}
                        </Timeline>
                    </div>
                }
                title={false}
                trigger={trigger||"click"}
                open={this.state.visible}
                placement={placement||"bottomRight"}
                onOpenChange={this.handleVisibleChange}
            >
                {this.props.children}
            </Popover>
        );
    }
}

OrderProgress.defaultProps = {
    code: 10,
    model:{}
};

OrderProgress.propTypes = {};
export default OrderProgress;
